// AIT-629: "Resets Sep 27" next to the usage figure: the quota window end
// the sidebar meter already fetches (NOT the Stripe renewal, which free and
// cancelled orgs do not have). Renders nothing when unknown. Quota windows
// are UTC (legacy ones end at UTC midnight), so format in UTC or a user west
// of Greenwich reads the previous day.
export function ResetsOn({ resetsAt }: { resetsAt?: string | null }) {
  if (!resetsAt) return null;
  const date = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' }).format(new Date(resetsAt));
  return <span className="text-sm text-muted-foreground">Resets {date}</span>;
}
